import type { RoutePathOptionType } from './type';

export const httpStatusCodes = {
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  SERVER_FAILED: 500,
};

export const routePathOptions: RoutePathOptionType[] = [
  {
    path: '/dashboard',
    label: 'Dashboard',
  },
  {
    path: '/orders',
    label: 'Orders',
    formType: {
      create: 'Add Order Details',
      edit: 'Edit Order Details',
      'order-summary': 'Order Summary',
    },
    showBackIcon: true,
    previousUrl: '/select-outfit',
  },
  {
    path: '/select-customer',
    label: 'Select or add customer',
    showBackIcon: true,
    previousUrl: '/dashboard',
  },
  {
    path: '/select-outfit',
    label: 'Select Outfits',
    showBackIcon: true,
    previousUrl: '/select-customer',
  },
  {
    path: '/create-order',
    label: 'Create Order',
  },
  {
    path: '/orders-list',
    label: 'Orders',
  },
  {
    path: '/customers',
    label: 'Customers',
  },
  {
    path: '/settings',
    label: 'Settings',
  },
  {
    path: '/settings/order-types',
    label: 'Order Types',
    breadcrumbs: ['Settings', 'Order Types'],
    showBackIcon: true,
    previousUrl: '/settings',
  },
  {
    path: '/settings/items-and-categories',
    label: 'Items and categories',
    breadcrumbs: ['Settings', 'Items and categories'],
    showBackIcon: true,
    previousUrl: '/settings',
  },
  {
    path: '/settings/items-and-categories/add-item',
    label: 'Edit item name and icon',
    breadcrumbs: ['Settings', 'Items and categories', 'Edit item name and icon'],
    showBackIcon: true,
    previousUrl: '/settings/items-and-categories',
  },
  {
    path: '/settings/items-and-categories/edit-item',
    label: 'Edit item name and icon',
    breadcrumbs: ['Settings', 'Items and categories', 'Edit item name and icon'],
    showBackIcon: true,
    previousUrl: '/settings/items-and-categories',
  },
  {
    path: '/settings/items-and-categories/edit-product',
    label: 'Edit product',
    breadcrumbs: ['Settings', 'Items and categories', 'Edit product'],
    showBackIcon: true,
    previousUrl: '/settings/items-and-categories',
  },
];

export const moneyFormatSigns = {
  rupee: '\u20B9',
};

export const GA_ID = 'G-67MM2LW547';
